<div
  class="card modern-card full-width"
  >
  <div class="card-header border-0 bg-transparent pt-3 px-4">
    <div class="d-flex justify-content-between align-items-center">
      <div class="header-content">
        <h1 class="modern-header">Email Templates</h1>
      </div>
      <button class="btn green-btn" (click)="saveDefaults()">
        <i class="fa fa-save me-2"></i>Save All Templates
      </button>
    </div>
  </div>

  <div class="card-body px-4 pb-4">
    <div class="row">
      @for (type of emailTypes; track type) {
        <div class="col-sm-12 col-xl-6 mb-4">
          <div class="card h-100 email-template-card shadow-sm">
            <div class="card-header email-template-header">
              <h5 class="mb-0 fw-medium">
                <i class="fa fa-envelope me-2"></i>{{ emailTypeLabels[type] || type }}
              </h5>
            </div>
            <div class="card-body">
              <form [formGroup]="getGroup(type)">
                <!-- Default Subject -->
                <div class="form-group d-flex align-items-center mb-3">
                  <label class="form-label" [for]="'defaultSubject' + type"
                    >Subject:</label
                    >
                    <input
                      type="text"
                      [id]="'defaultSubject' + type"
                      class="form-control flex-grow-1"
                      formControlName="subject"
                      placeholder="Enter default subject"
                      />
                    </div>
                    <!-- Default Body -->
                    <div class="form-group d-flex align-items-start mb-3">
                      <label class="form-label pt-2" [for]="'defaultBody' + type"
                        >Body:</label
                        >
                        <textarea
                          [id]="'defaultBody' + type"
                          class="form-control flex-grow-1"
                          formControlName="body"
                          rows="4"
                          placeholder="Enter default email body"
                        ></textarea>
                      </div>
                      <div class="d-flex gap-3 mt-3 flex-wrap align-items-center pt-3 border-top border-secondary"
                        >
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            [id]="'includeFooter' + type"
                            formControlName="include_footer"
                            />
                            <label
                              class="form-check-label"
                              [for]="'includeFooter' + type"
                              >
                              Footer
                            </label>
                          </div>
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              [id]="'includeFfl' + type"
                              formControlName="include_ffl"
                              [style.cursor]="!isFflDocumentUploaded() ? 'not-allowed' : 'pointer'"
                              />
                              <label
                                class="form-check-label"
                                [for]="isFflDocumentUploaded() ? 'includeFfl' + type : ''"
                                [style.opacity]="!isFflDocumentUploaded() ? '0.5' : '1'"
                                [style.cursor]="!isFflDocumentUploaded() ? 'not-allowed' : 'pointer'"
                                [tooltip]="!isFflDocumentUploaded() ? 'Upload FFL document to enable' : ''"
                                placement="bottom"
                                container="body"
                                >
                                FFL
                              </label>
                            </div>
                            <div class="form-check">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                [id]="'includeSot' + type"
                                formControlName="include_sot"
                                [style.cursor]="!isSotDocumentUploaded() ? 'not-allowed' : 'pointer'"
                                />
                                <label
                                  class="form-check-label"
                                  [for]="isSotDocumentUploaded() ? 'includeSot' + type : ''"
                                  [style.opacity]="!isSotDocumentUploaded() ? '0.5' : '1'"
                                  [style.cursor]="!isSotDocumentUploaded() ? 'not-allowed' : 'pointer'"
                                  [tooltip]="!isSotDocumentUploaded() ? 'Upload SOT document to enable' : ''"
                                  placement="bottom"
                                  container="body"
                                  >
                                  SOT
                                </label>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
